import { IBusTuyenDuongSelectRequest } from "../../../models/request/bus/busBaoCaoDiemDanhRequest";
import { IBusDangKyXeSaveRequest } from "../../../models/request/bus/busDangKyXeSaveRequest";
import { IUploadExcelRequest } from "../../../models/request/bus/uploadExcelRequest";
import { BusDangKyXeItemResponse } from "../../../models/response/bus/bus_dangkyxe";
import { BusDiemDonTraItemResponse } from "../../../models/response/bus/bus_diemdontra";
import { bus_hinhthuc_dangky } from "../../../models/response/bus/bus_hinhthuc_dangky";
import { bus_hinhthuc_dontra } from "../../../models/response/bus/bus_hinhthuc_dontra";
import { bus_loaidiemdon } from "../../../models/response/bus/bus_loaidiemdon";
import { bus_trangthai_dangky } from "../../../models/response/bus/bus_trangthai_dangky";
import { BusTuyenDuongItemResponse } from "../../../models/response/bus/bus_tuyenduong";
import { BusTuyenDuongChiTietItemResponse } from "../../../models/response/bus/bus_tuyenduong_chitiet";
import {
	eBusDangKyXeActionTypeIds,
	IBusDangKyXeChangeFilterTrangThai,
	IBusDangKyXeChangeSelectedIds,
	IBusDangKyXeCloseConfirm,
	IBusDangKyXeCloseDetail,
	IBusDangKyXeCloseImportModal,
	IBusDangKyXeCloseTuyenDuongChiTietModal,
	IBusDangKyXeDeleteErr,
	IBusDangKyXeDeleteStart,
	IBusDangKyXeDeleteSuccess,
	IBusDangKyXeDiemDonTraLoadErr,
	IBusDangKyXeDiemDonTraLoadStart,
	IBusDangKyXeDiemDonTraLoadSuccess,
	IBusDangKyXeImportErr,
	IBusDangKyXeImportStart,
	IBusDangKyXeImportSuccess,
	IBusDangKyXeLoadDetailErr,
	IBusDangKyXeLoadDetailStart,
	IBusDangKyXeLoadDetailSuccess,
	IBusDangKyXeLoadErr,
	IBusDangKyXeLoadStart,
	IBusDangKyXeLoadSuccess,
	IBusDangKyXeSaveErr,
	IBusDangKyXeSaveStart,
	IBusDangKyXeSaveSuccess,
	IBusDangKyXeSelectDiemDonTraRequest,
	IBusDangKyXeShowConfirm,
	IBusDangKyXeShowDetail,
	IBusDangKyXeShowImportModal,
	IBusDangKyXeShowTuyenDuongChiTietModal,
	IBusDangKyXeTuyenDuongChiTietLoadErr,
	IBusDangKyXeTuyenDuongChiTietLoadStart,
	IBusDangKyXeTuyenDuongChiTietLoadSuccess,
	IBusDangKyXeTuyenDuongLoadErr,
	IBusDangKyXeTuyenDuongLoadStart,
	IBusDangKyXeTuyenDuongLoadSuccess,
	IBusDangKyXeValidateImportErr,
	IBusDangKyXeValidateImportStart,
	IBusDangKyXeValidateImportSuccess,
	IBusHinhThucDangKyLoadErr,
	IBusHinhThucDangKyLoadStart,
	IBusHinhThucDangKyLoadSuccess,
	IBusHinhThucDonTraLoadErr,
	IBusHinhThucDonTraLoadStart,
	IBusHinhThucDonTraLoadSuccess,
	IBusLoaiDiemDonLoadErr,
	IBusLoaiDiemDonLoadStart,
	IBusLoaiDiemDonLoadSuccess,
	IBusTrangThaiDangKyLoadErr,
	IBusTrangThaiDangKyLoadStart,
	IBusTrangThaiDangKyLoadSuccess
} from "../../action-types/bus/IBusDangKyXeActionTypes";

export const busDangKyXeActions = {
	loadBusDangKyXeStart: (request: IBusTuyenDuongSelectRequest): IBusDangKyXeLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_START,
			payload: request
		}
	},
	loadBusDangKyXeSuccess: (data: BusDangKyXeItemResponse[]): IBusDangKyXeLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_SUCCESS,
			payload: data
		}
	},
	loadBusDangKyXeError: (message: string): IBusDangKyXeLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_ERROR,
			payload: message
		}
	},
	loadBusDangKyXeDetailStart: (id: number): IBusDangKyXeLoadDetailStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_DETAIL_START,
			payload: id
		}
	},
	loadBusDangKyXeDetailSuccess: (data: BusDangKyXeItemResponse): IBusDangKyXeLoadDetailSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_DETAIL_SUCCESS,
			payload: data
		}
	},
	loadBusDangKyXeDetailError: (message: string): IBusDangKyXeLoadDetailErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_DETAIL_ERROR,
			payload: message
		}
	},
	loadBusHinhThucDonTraStart: (): IBusHinhThucDonTraLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_START
		}
	},
	loadBusHinhThucDonTraSuccess: (data: bus_hinhthuc_dontra[]): IBusHinhThucDonTraLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_SUCCESS,
			payload: data
		}
	},
	loadBusHinhThucDonTraError: (message: string): IBusHinhThucDonTraLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DONTRA_ERROR,
			payload: message
		}
	},
	loadBusHinhThucDangKyStart: (): IBusHinhThucDangKyLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_START
		}
	},
	loadBusHinhThucDangKySuccess: (data: bus_hinhthuc_dangky[]): IBusHinhThucDangKyLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_SUCCESS,
			payload: data
		}
	},
	loadBusHinhThucDangKyError: (message: string): IBusHinhThucDangKyLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_HINHTHUC_DANGKY_ERROR,
			payload: message
		}
	},
	loadBusLoaiDiemDonStart: (): IBusLoaiDiemDonLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_START
		}
	},
	loadBusLoaiDiemDonSuccess: (data: bus_loaidiemdon[]): IBusLoaiDiemDonLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_SUCCESS,
			payload: data
		}
	},
	loadBusLoaiDiemDonError: (message: string): IBusLoaiDiemDonLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_LOAIDIEMDON_ERROR,
			payload: message
		}
	},
	loadBusTrangThaiDangKyStart: (): IBusTrangThaiDangKyLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_START
		}
	},
	loadBusTrangThaiDangKySuccess: (data: bus_trangthai_dangky[]): IBusTrangThaiDangKyLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_SUCCESS,
			payload: data
		}
	},
	loadBusTrangThaiDangKyError: (message: string): IBusTrangThaiDangKyLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TRANGTHAI_DANGKY_ERROR,
			payload: message
		}
	},
	loadBusTuyenDuongStart: (request: IBusTuyenDuongSelectRequest): IBusDangKyXeTuyenDuongLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_START,
			payload: request
		}
	},
	loadBusTuyenDuongSuccess: (data: BusTuyenDuongItemResponse[]): IBusDangKyXeTuyenDuongLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_SUCCESS,
			payload: data
		}
	},
	loadBusTuyenDuongError: (message: string): IBusDangKyXeTuyenDuongLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_ERROR,
			payload: message
		}
	},
	loadBusDiemDonTraStart: (request: IBusDangKyXeSelectDiemDonTraRequest): IBusDangKyXeDiemDonTraLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_START,
			payload: request
		}
	},
	loadBusDiemDonTraSuccess: (data: BusDiemDonTraItemResponse[]): IBusDangKyXeDiemDonTraLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_SUCCESS,
			payload: data
		}
	},
	loadBusDiemDonTraError: (message: string): IBusDangKyXeDiemDonTraLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_DIEMDONTRA_ERROR,
			payload: message
		}
	},
	loadBusTuyenDuongChiTietStart: (bus_tuyenduong_id: number): IBusDangKyXeTuyenDuongChiTietLoadStart => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_START,
			payload: bus_tuyenduong_id
		}
	},
	loadBusTuyenDuongChiTietSuccess: (data: BusTuyenDuongChiTietItemResponse[]): IBusDangKyXeTuyenDuongChiTietLoadSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_SUCCESS,
			payload: data
		}
	},
	loadBusTuyenDuongChiTietError: (message: string): IBusDangKyXeTuyenDuongChiTietLoadErr => {
		return {
			type: eBusDangKyXeActionTypeIds.LOAD_TUYENDUONG_CHITIET_ERROR,
			payload: message
		}
	},
	showBusDangKyXeDetail: (data?: BusDangKyXeItemResponse): IBusDangKyXeShowDetail => {
		return {
			type: eBusDangKyXeActionTypeIds.SHOW_DETAIL,
			payload: data
		}
	},
	closeBusDangKyXeDetail: (): IBusDangKyXeCloseDetail => {
		return {
			type: eBusDangKyXeActionTypeIds.CLOSE_DETAIL
		}
	},
	showBusTuyenDuongChiTietModal: (bus_tuyenduong_id: number): IBusDangKyXeShowTuyenDuongChiTietModal => {
		return {
			type: eBusDangKyXeActionTypeIds.SHOW_TUYENDUONG_CHITIET_MODAL,
			payload: bus_tuyenduong_id
		}
	},
	closeBusTuyenDuongChiTietModal: (): IBusDangKyXeCloseTuyenDuongChiTietModal => {
		return {
			type: eBusDangKyXeActionTypeIds.CLOSE_TUYENDUONG_CHITIET_MODAL
		}
	},
	changeBusDangKyXeSelectedIds: (ids: number[]): IBusDangKyXeChangeSelectedIds => {
		return {
			type: eBusDangKyXeActionTypeIds.CHANGE_SELECTED_IDS,
			payload: ids
		}
	},
	changeBusDangKyXeFilterTrangThai: (bus_trangthai_id: number): IBusDangKyXeChangeFilterTrangThai => {
		return {
			type: eBusDangKyXeActionTypeIds.CHANGE_FILTER_TRANGTHAI,
			payload: bus_trangthai_id
		}
	},
	showBusDangKyXeConfirm: (): IBusDangKyXeShowConfirm => {
		return {
			type: eBusDangKyXeActionTypeIds.SHOW_CONFIRM
		}
	},
	closeBusDangKyXeConfirm: (): IBusDangKyXeCloseConfirm => {
		return {
			type: eBusDangKyXeActionTypeIds.CLOSE_CONFIRM
		}
	},
	saveBusDangKyXeStart: (data: IBusDangKyXeSaveRequest): IBusDangKyXeSaveStart => {
		return {
			type: eBusDangKyXeActionTypeIds.SAVE_START,
			payload: data
		}
	},
	saveBusDangKyXeSuccess: (is_update: boolean): IBusDangKyXeSaveSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.SAVE_SUCCESS,
			payload: is_update
		}
	},
	saveBusDangKyXeError: (message: string): IBusDangKyXeSaveErr => {
		return {
			type: eBusDangKyXeActionTypeIds.SAVE_ERROR,
			payload: message
		}
	},
	deleteBusDangKyXeStart: (id: number): IBusDangKyXeDeleteStart => {
		return {
			type: eBusDangKyXeActionTypeIds.DELETE_START,
			payload: id
		}
	},
	deleteBusDangKyXeSuccess: (): IBusDangKyXeDeleteSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.DELETE_SUCCESS
		}
	},
	deleteBusDangKyXeError: (message: string): IBusDangKyXeDeleteErr => {
		return {
			type: eBusDangKyXeActionTypeIds.DELETE_ERROR,
			payload: message
		}
	},
	showBusDangKyXeImportModal: (): IBusDangKyXeShowImportModal => {
		return {
			type: eBusDangKyXeActionTypeIds.SHOW_IMPORT_MODAL
		}
	},
	closeBusDangKyXeImportModal: (): IBusDangKyXeCloseImportModal => {
		return {
			type: eBusDangKyXeActionTypeIds.CLOSE_IMPORT_MODAL
		}
	},
	validateImportBusDangKyXeStart: (request: IUploadExcelRequest): IBusDangKyXeValidateImportStart => {
		return {
			type: eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_START,
			payload: request
		}
	},
	validateImportBusDangKyXeSuccess: (data: any[]): IBusDangKyXeValidateImportSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_SUCCESS,
			payload: data
		}
	},
	validateImportBusDangKyXeError: (message: string): IBusDangKyXeValidateImportErr => {
		return {
			type: eBusDangKyXeActionTypeIds.VALIDATE_IMPORT_ERROR,
			payload: message
		}
	},
	importBusDangKyXeStart: (request: IUploadExcelRequest): IBusDangKyXeImportStart => {
		return {
			type: eBusDangKyXeActionTypeIds.IMPORT_START,
			payload: request
		}
	},
	importBusDangKyXeSuccess: (): IBusDangKyXeImportSuccess => {
		return {
			type: eBusDangKyXeActionTypeIds.IMPORT_SUCCESS
		}
	},
	importBusDangKyXeError: (message: string): IBusDangKyXeImportErr => {
		return {
			type: eBusDangKyXeActionTypeIds.IMPORT_ERROR,
			payload: message
		}
	}
}
